import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_2xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * Applied to `BaseFlyout` itself (the class lands on the portal, so descendant
 * selectors reach the panel). Mirrors `SpendRestrictionsTile.style.ts`'s
 * `flyoutStyle`: the same fixed 640px width and raised white surface the
 * design specifies for every settings drawer, not just the two that shipped
 * first — BaseFlyout's own preferredWidth is spacing(145) = 580px.
 */
export const flyoutStyle = css`
  &.SettingsDrawerShell {
    .BaseFlyout-Content {
      background-color: ${base_colorRaisedSurface};
      width: min(${spacing(160)}, 100vw);

      .BaseFlyout-CloseBar,
      .BaseFlyout-Body {
        background-color: ${base_colorRaisedSurface};
      }
    }
  }
`

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};

  /*
   * Content-owned heading, matching the two existing drawers: BaseFlyout's own
   * \`title\`/\`subtitle\` render a raised header band, but the design is a
   * single flat surface, so this shell passes neither and styles its own
   * heading block instead.
   */
  .SettingsDrawerShell-heading h2 {
    margin: 0 0 6px;
    font-family: ${font_family_weight_medium};
    ${font_2xl};
    color: ${text_colorTextPrimary};
  }

  .SettingsDrawerShell-lead {
    margin: 0 0 ${spacing(1)};
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextSecondary};
  }

  .SettingsDrawerShell-section {
    border-top: 1px solid ${base_colorContentBorder};
    margin-top: ${spacing(4)};
    padding-top: ${spacing(4)};
  }

  /* Closing info note. The glyph is decorative — the sentence beside it
     carries the meaning. */
  .SettingsDrawerShell-footnote {
    display: flex;
    align-items: flex-start;
    gap: ${spacing(2)};
    margin: ${spacing(4)} 0 0;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .SettingsDrawerShell-footnote > svg {
    flex: 0 0 auto;
    margin-top: ${spacing(0.25)};
  }

  /* SvgTooltip defaults its fill to the CTA colour; this decorative glyph
     inherits the note's own secondary grey instead, matching the design's
     currentColor glyph. A presentation attribute loses to any CSS rule, so
     this wins over the inline fill. */
  .SettingsDrawerShell-footnote > svg g {
    fill: currentColor;
  }
`
